import styled from 'styled-components';
import { theme } from 'styles/colorPalette';

export const StyledToolbar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.toolbarBackground};
  border-radius: 5px;
  padding: 10px 20px;
  margin-bottom: 10px;
  div {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;
